// Module
var code = "<csv-mapping columns=\"vm.columns\" optional-attributes=\"vm.optionalAttributes\" mandatory-attributes=\"vm.mandatoryAttributes\" data=\"vm.data\" submitted=\"vm.submitted\"> </csv-mapping> ";
// Exports
module.exports = code;